import axios from 'axios';
import {toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const util = require('../utils/index');
const process = require('../env');

const getCredentials = () => {
  const userLogged = util.getUser();

  const credentials = {
    username: userLogged.login,
    password: userLogged.senha
  }

  return credentials;
}


export const registrarTurmaApi = async (formValue) => {
  try{
  
      const response = await axios.post(`${process.env.URL}/class/createClass`, formValue, {
        auth: getCredentials()
      })
  
      if (response.status === 200){
        return true;
      }

    }catch(e){
     toast.error(e.response.data['message']);
    }
  return false;
}


export const listarTurmaApi = async (body) => {
  try{
      const response = await axios.post(`${process.env.URL}/class/getClasses`, body, {
        auth: getCredentials()
      })
      const users = response.data
      if (response.status === 200){
        return users;
      }
      

    }catch(e){
     toast.error(e.response.data['message']);
    }
  return false;
}

export const pegarTurmaApi = async (id) => {
  try{
      const response = await axios.post(`${process.env.URL}/class/getClassByID`, id, {
        auth: getCredentials()
      })
      const user = response.data
      if (response.status === 200){
        return user;
      }
      

    }catch(e){
     toast.error(e.response.data['message']);
    }
  return false;
}

export const atualizarTurmaApi = async (formValue) => {
  try{
      const response = await axios.put(`${process.env.URL}/class/updateclass`, formValue, {
        auth: getCredentials()
      })
      if (response.status === 200){
        return true;
      }
      

    }catch(e){
     toast.error(e.response.data['message']);
    }
  return false;
}

export const excluirTurmaApi = async (formValue) => {
  try{
      const response = await axios.post(`${process.env.URL}/class/deleteclass`, formValue, {
        auth: getCredentials()
      })
      if (response.status === 200){
        return true;
      }
      

    }catch(e){
     toast.error(e.response.data['message']);

    }
  return false;
}